/*
* jQuery Open/Close plugin
*/
;(function($) {
function CustomOpenClose(options) {
	this.options = $.extend({
	activeClass: 'active',
	items: '.item',
	opener: '.opener',
	closer: '.close',
	slider: '.slide',
	animSpeed: 400,
	effect: 'slide'
	}, options);
	this.init();
}
CustomOpenClose.prototype = {
	init: function() {
	if(this.options.holder) {
		this.findElements();
		this.attachEvents();
		this.makeCallback('onInit', this);
	}
	},
	findElements: function() {
	var self = this;

	this.win = jQuery(window);
	this.holder = $(this.options.holder);
	this.items = this.holder.find(this.options.items).has(this.options.slider);
	this.structure = [];
	this.busy = false;
	this.isAnimating = false;
	this.prevActive = {};

	this.items.each(function() {
		var item = jQuery(this);
		var opener = item.find(self.options.opener);
		var closer = item.find(self.options.closer);
		var slider = item.find(self.options.slider);

		self.structure.push({
		item: item,
		opener: opener,
		closer: closer,
		slider: slider
		});
	});
	},
	attachEvents: function() {
	// add handler
	var self = this;

	this.clickHandler = function(e) {
		var obj = e.data;
	
		if ($(e.target).is('a') || $(e.target).closest('a').length) {
			return;
		}
	
		if (!self.isAnimating) {
			if (obj.item.hasClass(self.options.activeClass)) {
				self.hideSlide(obj);
			} else {
				if (!$.isEmptyObject(self.prevActive)) {
					var animFlag = self.checkOffset(self.prevActive.item, obj.item);
	
					self.hideSlide(self.prevActive, animFlag);
					self.showSlide(obj, animFlag);
				} else {
					self.showSlide(obj);
				}
			}
		}
		e.preventDefault();
	};	

	this.hideClickHandler = function(e) {
		var obj = e.data;

		if (!self.isAnimating) {
		if (obj.item.hasClass(self.options.activeClass)) {
			self.hideSlide(obj);
		}
		}
		e.preventDefault();
	}

	this.resizeHandler = function() {
		if(!self.busy && !self.isAnimating){
		self.onWindowResize();
		}
	};

	this.holder.on('click', this.options.slider + ' a', function(e) {
		e.stopPropagation();
	
		if (!e.ctrlKey && !e.metaKey && $(this).attr('target') !== '_blank') {
			e.preventDefault();
			window.location.href = this.href;
		}
	});	

	this.holder.on('click', this.options.slider, function(e) {
		if (!$(e.target).is('a') && !$(e.target).closest('a').length) {
			var activeItem = self.items.filter('.' + self.options.activeClass);
			if (activeItem.length) {
				self.hideSlide({ item: activeItem, slider: activeItem.find(self.options.slider) });
			}
		}
	});

	$(document).on('click', '.routing-tabs-list > li', function() {
		var activeItem = self.items.filter('.' + self.options.activeClass);
		if (activeItem.length) {
			self.hideSlide({ item: activeItem, slider: activeItem.find(self.options.slider) });
		}
	});

	$(document).on('click', function(e) {
		if ($(window).width() <= 1023) { 
			var clickedBlock = $(e.target).closest('.routing-block-posts');
			var activeItem = self.items.filter('.' + self.options.activeClass);
	
			if (clickedBlock.length && activeItem.length && !clickedBlock.has(activeItem).length) {
				self.hideSlide({ item: activeItem, slider: activeItem.find(self.options.slider) });
			}
		}
	});

	this.structure.forEach(function(obj) {
		// set initial styles
		if (obj.item.hasClass(self.options.activeClass)) {
		self.items.not(obj.item).removeClass(self.options.activeClass);
		self.prevActive = obj;
		self.showSlide(self.prevActive, true);
		} else {
		self.hideSlide(obj, true);
		}
		// add click handler
		if (obj.opener.length) {
		obj.opener.on('click', obj, self.clickHandler);
		}
		if (obj.closer.length) {
		obj.closer.on('click', obj, self.hideClickHandler);
		}
	});

	// add resize handler
	this.win.on('load resize orientationchange', this.resizeHandler)
	},
	checkOffset: function(prevItem, newItem) {
	return Math.floor(prevItem.offset().top) === Math.floor(newItem.offset().top);
	},
	refreshDimensions: function(obj) {
	var self = this;
	var hidden = false;

	if (obj.slider.hasClass(slideHiddenClass)) {
		hidden = true;
		obj.slider.removeClass(slideHiddenClass).show();
	}

	obj.slider.css({
		'transform': '',
		'visibility': 'hidden'
	});

	obj.slider.css({
		'width': self.holder.width(),
		'transform': 'translateX(' + (self.holder.offset().left - obj.slider.offset().left) + 'px)',
		'visibility': ''
	});

	if (hidden) {
		obj.slider.addClass(slideHiddenClass).hide();
	}

	return this;
	},
	onWindowResize: function() {
	var self = this;
	this.structure.forEach(function(obj) {
		self.refreshDimensions(obj);
	});
	},
	showSlide: function(obj, noAnim) {
	var self = this;

	this.isAnimating = true;

	obj.item.addClass(self.options.activeClass);
	obj.slider.removeClass(slideHiddenClass);

	this.makeCallback('animStart', true);

	toggleEffects[self.options.effect].show({
		box: obj.slider,
		speed: noAnim ? 0 : this.options.animSpeed,
		complete: function() {
		self.isAnimating = false;
		self.makeCallback('animEnd', true);
		}
	});
	if ($(window).width() <= 1023) {
		setTimeout(function() {
			var offset = obj.item.offset().top - 70;
			$('html, body').animate({ scrollTop: offset }, 400);
		}, self.options.animSpeed);
	}	
	this.prevActive = obj;
	},
	hideSlide: function(obj, noAnim) {
	var self = this;

	this.isAnimating = true;

	this.makeCallback('animStart', false);

	obj.item.removeClass(self.options.activeClass);

	toggleEffects[self.options.effect].hide({
		box: obj.slider,
		speed: noAnim ? 0 : this.options.animSpeed,
		complete: function() {
		obj.slider.addClass(slideHiddenClass);
		self.isAnimating = false;
		self.makeCallback('animEnd', false);
		}
	});

	this.prevActive = {};
	},
	destroy: function() {
	this.busy = true;
	this.win.off('resize orientationchange', this.resizeHandler);
	this.structure.forEach(function(obj) {
		obj.slider.removeClass(slideHiddenClass).stop().removeAttr('style');
		obj.item.removeClass(self.options.activeClass).removeAttr('style');
		obj.opener.off('click', obj, self.clickHandler);
		obj.closer.off('click', obj, self.hideClickHandler);
	});
	this.holder.removeData('CustomOpenClose');
	},
	makeCallback: function(name) {
	if(typeof this.options[name] === 'function') {
		var args = Array.prototype.slice.call(arguments);
		args.shift();
		this.options[name].apply(this, args);
	}
	}
};

// add stylesheet for slide on DOMReady
var slideHiddenClass = 'js-custom-slide-hidden';
(function() {
	var tabStyleSheet = $('<style type="text/css">')[0];
	var tabStyleRule = '.' + slideHiddenClass;
	tabStyleRule += '{position:absolute !important;visibility:hidden !important;display:block !important}';
	if (tabStyleSheet.styleSheet) {
	tabStyleSheet.styleSheet.cssText = tabStyleRule;
	} else {
	tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
	}
	$('head').append(tabStyleSheet);
}());

// animation effects
var toggleEffects = {
	slide: {
	show: function(o) {
		o.box.stop(true).hide().slideDown(o.speed, o.complete);
	},
	hide: function(o) {
		o.box.stop(true).slideUp(o.speed, o.complete);
	}
	},
	fade: {
	show: function(o) {
		o.box.stop(true).hide().fadeIn(o.speed, o.complete);
	},
	hide: function(o) {
		o.box.stop(true).fadeOut(o.speed, o.complete);
	}
	},
	none: {
	show: function(o) {
		o.box.hide().show(0, o.complete);
	},
	hide: function(o) {
		o.box.hide(0, o.complete);
	}
	}
};

// jQuery plugin interface
$.fn.customOpenClose = function(opt) {
	return this.each(function() {
	jQuery(this).data('CustomOpenClose', new CustomOpenClose($.extend(opt, { holder: this })));
	});
};
}(jQuery));